import { render, staticRenderFns } from "./ToggleFiltersButton.vue?vue&type=template&id=1b3c3f70&scoped=true&"
import script from "./ToggleFiltersButton.vue?vue&type=script&lang=ts&"
export * from "./ToggleFiltersButton.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleFiltersButton.vue?vue&type=style&index=0&id=1b3c3f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c3f70",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsFilter24px: require('/var/www/packages/theme/components/icons/filter/Filter24px.vue').default,AtomsCounter: require('/var/www/packages/theme/components/atoms/Counter.vue').default})
